/* eslint-disable @typescript-eslint/no-explicit-any */
import { tutorialFragment } from "../fragments";
import {
    ITemplatePageLoader,
    flattenTemplateImageAssets
} from "../get-content-data";

export const AgileTutorialPageLoader: ITemplatePageLoader = {
    getQueryData: (urlSlug: string, locale: string) => {
        return {
            query: `
                query getAgileTutorials ($search: ContentPlatformSearchAPIv2Query!) {
                    fullTutorials(search: $search) {
                        edges {
                            node {
                                ...tutorialsFragmentFull
                            }
                        }
                    }
                }
                ${tutorialFragment}
            `,
            variables: {
                search: {
                    queries: {
                        first: 1,
                        withLocales: [locale],
                        where: {
                            searchText: {
                                exactlyMatching: {
                                    fieldNamed: "tutorialRef.urlSlug",
                                    havingValues: [urlSlug]
                                }
                            }
                        }
                    }
                }
            }
        };
    },
    parseData: (data: any) => {
        const flattenedTutorial = flattenTemplateImageAssets(
            data.fullTutorials.edges?.[0]?.node ?? {}
        );
        return { ...flattenedTutorial, ...flattenedTutorial.tutorialRef };
    }
};
